var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"dsp-2022-cycle"},[_c('dsp-header'),(_vm.$vuetify.breakpoint.mdAndUp)?_c('sidebar'):_vm._e(),_c('v-main',{staticClass:"white",attrs:{"app":""}},[_c('router-view',{attrs:{"show-stats":_vm.mini,"narrative-stats":_vm.narrativeStats,"state-stats":_vm.stateStats}})],1),_c('dsp-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }